module.exports = __webpack_public_path__ + "static/media/Carnation.85952c76.jpg";